// axiosInstances.js

import axios from "axios";

const createInstance = (baseURL, headers = {}) => {
  return axios.create({
    baseURL,
    timeout: parseInt(`${process.env.REACT_APP_REQUEST_TIMEOUT}`),
    headers,
  });
};

export const axiosInstanceAuth = createInstance(
  `${process.env.REACT_APP_BASE_AUTH_URL_API}`,
);
export const axiosInstanceCore = createInstance(
  `${process.env.REACT_APP_BASE_AUTH_URL_API}`,
);
export const axiosInstanceAsset = createInstance(
  `${process.env.REACT_APP_BASE_URL_ASSET_API}`,
  {
    "Content-Type": "multipart/form-data",
    "X-Kartini-Signature": process.env.REACT_APP_KARTINI_SIGNATURE,
  },
);
export const axiosInstanceAI = createInstance(
  `${process.env.REACT_APP_BASE_URL_AI}`,
  {
    "Content-Type": "application/json",
    "X-Kartini-Signature": process.env.REACT_APP_KARTINI_SIGNATURE,
  },
);
// Tambah instance baru jika di perlukan
